var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.6055 21.8752L25.3555 28.1252L19.1055 21.8752",
    stroke: "#41B64D",
    strokeWidth: 3.32143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.52148 25.0003C4.52148 15.1794 4.52148 10.2689 7.57246 7.21796C10.6234 4.16699 15.5339 4.16699 25.3548 4.16699C35.1757 4.16699 40.0862 4.16699 43.1372 7.21796C46.1881 10.2689 46.1881 15.1794 46.1881 25.0003C46.1881 34.8213 46.1881 39.7317 43.1372 42.7827C40.0862 45.8337 35.1757 45.8337 25.3548 45.8337C15.5339 45.8337 10.6234 45.8337 7.57246 42.7827C4.52148 39.7317 4.52148 34.8213 4.52148 25.0003Z",
    stroke: "#41B64D",
    strokeWidth: 3.32143
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenArrowDown);
export default __webpack_public_path__ + "static/media/greenArrowDown.a8cff020d599721c6764d923d8984a44.svg";
export { ForwardRef as ReactComponent };